import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {platform} from "@/api/platform";
import {retryRequest} from "@/helpers/request";

export interface CatalogMessage {
    message: string
    email: string | null
}

// Legacy single message, or a list of messages (plain strings or with an email)
export type CatalogMessagesResponse =
    | {message: string, email?: string | null}
    | (string | CatalogMessage)[]

const catalog: Module<Record<string, never>, RootState> = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getCatalogMessages(): Promise<CatalogMessage[]> {

            const userId = this.getters["user/id"];

            return retryRequest(() => platform.get<{results: CatalogMessagesResponse}>(`/api/v2/user/${userId}/catalog-message`))
                .then(response => {

                    const results = response.data.results as CatalogMessagesResponse & {message?: string, email?: string | null};

                    // Check for we still have legacy format (single message)
                    if (results.message) {

                        return [{message: results.message, email: results.email ?? null}];
                    }

                    if (Array.isArray(results) && 0 < results.length) {

                        return results.map(
                            (item) => "string" === typeof item
                                ? {message: item, email: null}
                                : {message: item.message, email: item.email}
                        );
                    }

                    return [];
                });
        }
    }
}

export default catalog
